var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42489 0.236373C1.09795 -0.0794053 0.568492 -0.077843 0.243167 0.239302C-0.08236 0.556642 -0.0807494 1.07005 0.246186 1.38583L3.98119 4.9998L0.246187 8.61376C-0.0807491 8.92954 -0.0823596 9.44295 0.243167 9.76029C0.568493 10.0774 1.09795 10.079 1.42489 9.76322L5.75679 5.5714C6.08231 5.25425 6.0807 4.74065 5.75377 4.42507L1.42489 0.236373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 6,
    fill: "white",
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.688c59a9e8cc8aeebbdd09219bf7ba17.svg";
export { ForwardRef as ReactComponent };